import { render } from "./ShiftDialog.vue?vue&type=template&id=98f0e010&scoped=true"
import script from "./ShiftDialog.vue?vue&type=script&lang=js"
export * from "./ShiftDialog.vue?vue&type=script&lang=js"

import "./ShiftDialog.vue?vue&type=style&index=0&id=98f0e010&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98f0e010"]])

export default __exports__